/*
 * Copyright (c) 2024 AccelByte Inc. All Rights Reserved
 * This is licensed software from AccelByte Inc, for limitations
 * and restrictions contact your company contract manager.
 */

export class ProjectNameHelpers {
  static renderName(name: string) {
    // Might as well be `name || 'Unnamed Project'`, but went with explicit condition `name === ''` instead, so
    // that it's clear that it's possible that somehow, the created project name is empty.
    return name === '' ? 'Unnamed Project' : name
  }
}
